// extracted by mini-css-extract-plugin
module.exports = {"customDropdownIndicator":"styles_customDropdownIndicator__12FFp","multiPlaceholder":"styles_multiPlaceholder__43S6J"};